import styled from 'styled-components'

export const DiagramsListContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    .first-row-container {
        display: flex;
        margin: 32px 0;
        .export-import-button {
            padding: 6px;
            height: 36px;
            width: 130px;
            margin-left: 10px;
            background: var(--gray-0);
            border-radius: 3px;
        }
    }
    .no-outline-button {
        &:focus {
            outline: none;
        }
    }
    .no-diagram {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }

        a {
            color: var(--blue-500);
            font-size: 13px;
        }
    }

    .loading-spin {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }
    }

    .custom-list {
        thead {
            .custom-list-column-id {
                width: 50px;
            }

            .custom-list-column-actions {
                width: 74px;
            }
        }
    }
`
export const ImportBody = styled.div`
    font-size: 14px;
    .importLabel {
        margin-top: 8px;
        font-size: 16px;
        cursor: pointer;
        input[type='file'] {
            display: none;
        }
    }
`
